export default __webpack_public_path__ + "static/media/arrow-back.5319bcf7680f59b96ac7500dfebf0252.svg";